import { NavigationItem, NavigationnavUnion } from '@/lib/types';

import linkTargetTransformer from '@/hygraph/transformers/link-target.transformer';
import { TNavbarItem } from '@/services/navigation.service';

export default function navigationTransformer(
  navigation: NavigationnavUnion[] | undefined
): TNavbarItem[] {
  return (navigation || []).map(navigationItemTransformer);
}

export function navigationItemTransformer(item: NavigationItem): TNavbarItem {
  return {
    label: item.label,
    href: item.url || null,
    target: linkTargetTransformer(item.target) || null,
    items: (item.navigationItems || []).map(navigationItemTransformer),
  };
}
